export default "__VITE_ASSET__CvLh5zmT__"